import MembershipBusinessListResourceModel from '../../generated/types/model/resource/MembershipBusinessListResourceModel';

export default class MembershipBusinessListResourceViewModel extends MembershipBusinessListResourceModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
